import { Box } from '@chakra-ui/react';
import * as spinners from 'react-spinners';
const { BeatLoader } =
  // @ts-ignore
  typeof spinners.default !== 'undefined' ? spinners.default : spinners;

export default function PageLoading(props: { overlay?: boolean }) {
  return (
    <Box
      width={'100vw'}
      height={'100vh'}
      display={'flex'}
      justifyContent={'center'}
      alignItems={'center'}
      {...(props.overlay && {
        position: 'fixed',
        top: 0,
        left: 0,
        bg: 'white',
        zIndex: 9999999999,
      })}
    >
      <BeatLoader color="black" />
    </Box>
  );
}
